import React from "react"
import { path } from "ramda"
import CreditOpportunitiesModal from "../../CreditOpportunitiesModal"
import { ButtonLink } from "../../ButtonLink"
import NewPDRInfo from "./NewPDRInfo"
import MsrHistoryLink from "../../MsrHistoryLink"
import { formatDate } from "../../utils/formatter"
import { MSRBox, ButtonsBox, TitleBox, LinkFrame } from "./Styles/Shared.styles"
import { pgaComTld } from "../../utils"

export const Title = ({ text, dueDate }) => (
  <TitleBox>
    {`${text} ${dueDate ? ` | DUE ${formatDate(dueDate)}` : ""}`}{" "}
    <LinkFrame
      href="https://resources.pga.org/my-membership/earn-and-report-pdrs"
      target="_blank"
      rel="noopener noreferrer"
    >
      (Learn More)
    </LinkFrame>
  </TitleBox>
)

const MSRTitle = ({ dueDate }) => <Title text="PDR STATUS" dueDate={dueDate} />

const NewPDRCredits = ({ currentPerson }) => {
  const cohortCode = path(["pdrRequirements", "cohortCode"], currentPerson)
  const cycleEndsOn = path(["pdrRequirements", "cycleEndsOn"], currentPerson)
  const showDueDate = cohortCode === "LM" ? null : cycleEndsOn

  return (
    <MSRBox>
      <MSRTitle dueDate={showDueDate} />
      <NewPDRInfo currentPerson={currentPerson} />
      <ButtonsBox>
        <ButtonLink
          outline
          href={`https://${pgaComTld}/member/pdr/report-pdr`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-center msr-btn"
        >
          Report PDR Credits
        </ButtonLink>
        <CreditOpportunitiesModal />
      </ButtonsBox>
      <div>
        <MsrHistoryLink />
      </div>
    </MSRBox>
  )
}

export default NewPDRCredits
